import React, { useState, useEffect, useContext } from "react";
import "../../styles/preparepdf.css";

import { Link, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";

import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";

import DynamicIcon from "../../components/dynamicicon";
import JisButton from "../../components/controls/jisButton";
import JisPrompt from "../../components/jisprompt";
import JisCheckbox from "../../components/controls/jisCheckbox";
import JisDialogForm from "../../components/formdialog";
import JisInternalPay from "../../components/core/internal_pay";
import PdfViewer from "../../components/controls/pdfviewer";
import JisTabButton from "../../components/controls/jisTabButton";
import { AffidavitTemplate } from "../../components/external/AffidavitTemplate";
import Pagenated from "../../components/pagenated";
import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";

function AffidavitDocuments() {
  const location = useLocation();
  const { type } = useParams();

  const { activePage, token, profile, frequentData, setIsExpired, setAlert } =
    useContext(ShareContext);
  // console.log(profile);
  const [openSuccess, setOpenSuccess] = useState(false);
  //  const {temptype} = useParams();
  const [deleteBox, setDeleteBox] = useState(false);
  const tempUrl = `${Constants.apiUrl}/setup/templates/affidavit`;
  const [templates, setTemplates] = useState([]);
  const [openTemp, setOpenTemp] = useState(false);
  const [filterTemps, setFilterTemps] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [index, setIndex] = useState(-1);
  const [search, setSearch] = useState("");
  const [isSearch, setIsSearch] = useState(false);

  const [docs, setDocs] = useState([]);
  const [config, setConfig] = useState([]);
  // const [alert, setAlert] = useState({open:false, title:'', subtitle:'', code:-10, data:{}});
  const [isPay, setIsPay] = useState(false);
  const [selectedtempid, setSelectedTempId] = useState(0);
  const [scheduleWindow, setScheduleWindow] = useState(false);
  const [schedule, setSchedule] = useState({});
  const [confirmSelect, setConfirmSelect] = useState(false);
  const [confirmUpload, setConfirmUpload] = useState(false);
  const [activeSelect, setActiveSelect] = useState({});
  const [openOption, setOpenOption] = useState(false);
  const [isExhibits, setIsExhibits] = useState(false);
  const [option, setOption] = useState(""); //document or template
  const [countExhibits, setCountExhibits] = useState(1);
  const [affidavitAmt, setAffidavitAmt] = useState(0);
  const [exhibitAmt, setExhibitAmt] = useState(200);
  const [sealAmt, setSealAmt] =useState(250);
  const [amount, setAmount] = useState(0);
  const [divisionId, setDivisionId] = useState(0);
  const [err, setErr] = useState("");
  const navigate = useNavigate();
  const [isDetails, setIsDetails] = useState(false);
  const [activeUpline, setActiveUpline] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [tab, setTab] = useState("pending");
  
  const role =
    location.pathname == "/affidavits" ||
    location.pathname == "/affidavits/view"
      ? "user"
      : "cfo"; //this asume second url /cfo-affidavits
  console.log(`${location.pathname} and the role ${role}`);
  const [gateway, setGateway] = useState(null);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [count, setCount] = useState(0);

  // useEffect(() => {
  //   if (pageIndex >= 0) {
  //     onLoad();
  //   }
  // }, [pageIndex, tab, pageSize]);

  useEffect(() => {
    if (role === "cfo" || role === "user") {
      if (pageIndex >= 0) {
        if (search != null && Object.keys(search).length > 0) {
          onSearch(search);
        }
      } else {
        setPageIndex(0);
        onLoad();
      }
    } else if (pageIndex >= 0) {
      onLoad();
    }
  }, [pageIndex, pageSize, tab, search]);

  const onChangeTab = (t) => {
    setTab(t);
    setPageIndex(0);
  };
  const onCancel = () => {
    setIsPay(false);
    setSelectedTempId(0);
  };
  const onOk = () => {
    console.log("we are here already....");
    if (alert.code == 0) {
      //  var lk=`/AffidavitDocuments/${alert.data.templateId}/edit/${alert.data.uplineId}`;
      // navigate(lk)
      var a = {
        id: alert.data.docId,
        caseTitle: "N/A",
        caseNumber: "N/A",
        type: "affidavit",
        caseFeeId: alert.data.caseFeeId,
      };
      navigate("/view-document-template", { state: { item: a } });
    }

    setAlert({ open: false });
  };
  const onCompleted = () => {
    console.log("alert value");
    console.log(alert);
    var lk = `/AffidavitDocuments/${alert.data.templateId}/edit/${alert.data.uplineId}`;
    console.log(lk);
    navigate(lk);
  };

  useEffect(() => {
    
    LoadTemplates();

    onConfig();
    onLoad();
    getCurrentGateway();
  }, []);

  const onUplineView = (up, index) => {
    setIsDetails(true);
    var finalpath = "";
    if (!up.isTemplate) {
      finalpath = Constants.RelativeFiletoRelative(`${up.filename}`);
    } else {
      finalpath = `${Constants.baseurl}/template-document/${up.id}`;
    }

    console.log(finalpath);
    setPreviewUrl(finalpath);
  };

  useEffect(() => {
    var amt = affidavitAmt;
    if (isExhibits) {
      amt = (amt + exhibitAmt * countExhibits);
    }
    setAmount(amt+sealAmt);

    /* if(option=='template'){
      setAmount(affidavitAmt);
    }else if(option=='document'){
      
    } */
  }, [option, isExhibits, countExhibits]);
  useEffect(() => {
    if (config.length > 0) {
      const aff = config.find((d) => d.code == "affidavit-main");
      if (aff) {
        setAffidavitAmt(aff.fee);
      }
      const affex = config.find((d) => d.code == "Affidavit-exhibit");
      if (affex) {
        setExhibitAmt(affex.fee);
      }
      const affeseal = config.find((d) => d.code == "affidavit-seal");
      if (affeseal) {
        setSealAmt(affeseal.fee);
      }
    }
  }, [config]);

  const onView = (itm) => {
    // var a={id: itm.id, caseTitle: 'N/A',caseNumber:'N/A', type:'affidavit',caseFeeId: itm.caseFeeId,zoomLink: itm.zoomLink, schedule:itm.schedule   };
    navigate(
      `/affidavit-prepare/${itm.id}/${role}${isReadOnly && role === "user" ? "/template" : ""}`,
    );
  };

  const onSelectSchedule = (doc) => {
    setScheduleWindow(true);
    console.log(doc);

    setSchedule({ ...schedule, doc });
  };
  const onSaveSchedule = (e) => {
    e.preventDefault();
    console.log(schedule);
    var sch = {
      docid: schedule.doc.id,
      zoomLink: schedule.zoom,
      scheduledBy: profile.username,
      scheduleDate: schedule.date + " " + schedule.time,
    };

    const uploadurl = `${Constants.apiUrl}/filing/e-swearing/schedule/${schedule.doc.id}`;
    const formData = new FormData();

    // Sending the FormData using fetch
    setIsLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(sch),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          //saved already
          //first upldate the row and show dialog box
          //setFilterTemps(filterTemps.map(i => i.id === schedule.doc.id ? {...i, zoomLink:sch.zoomLink, schedule:sch.scheduleDate} : i));

          setSchedule({});

          setAlert({
            open: true,
            title: "Schedule an Appointment",
            subtitle: "Meeting Schedule is successful",
          });
          setScheduleWindow(false);
          onLoad();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const LoadTemplates = () => {
    setIsLoading(true);
    fetch(tempUrl, {
      method: "GET",
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          setTemplates(data.templates);
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  // const onSearch = (ee) => {
  //   setSearch(ee);
  //   if (ee != "") {
  //     const _filterSearch = docs?.filter((item) => {
  //       const searchValue =
  //         item.docUploadLines[0].documentTitle
  //           .toLowerCase()
  //           .includes(ee.toLowerCase()) ||
  //         item.refid?.toLowerCase().includes(ee.toLowerCase());

  //       return searchValue;
  //     });
  //     setFilterTemps(_filterSearch);
  //   } else {
  //     setFilterTemps(docs);
  //   }
  // };

  const onDelete = () => {
    setDeleteBox(false);
  };

  const onNewTemplate = () => {
    setOpenOption(true);
  };

  const onCloseTemp = () => {
    setOpenTemp(false);
  };

  const onSelectTemplate = (selected) => {
    console.log(selected.id);

    setActiveSelect(selected);
    setSelectedTempId(selected.id);
    setConfirmSelect(true);
    onCloseTemp();
    // setIsPay(true);
  };

  const onConfirmSelect = async () => {
    // setConfirmSelect(false);
    // setIsPay(true);
    setIsLoading(true);
    const note = `affidavit-${option}-${selectedtempid}-${isExhibits}-${countExhibits}-${divisionId}`;
    const pi = note.split("-");

    try {
      var payinfo = {
        id: 0,
        payType: pi[0],
        note,
        amount,
        gatewayId: gateway.id,
        isPaid: false,
        divisionId: pi[5],
        externalAmount: amount - sealAmt,
        internalAmount: sealAmt,
      };
      const resp = await fetch(
        `${Constants.apiUrl}/payment/initiate-internal-pay`,
        {
          method: "POST",
          body: JSON.stringify(payinfo),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setIsLoading(false);
      console.log(data);
      if (data.code === 0) {
        //setGazettes(data.gazettes);
        console.log("bill... " + data.id);
        var bill = `JISI${data.id}`;
        localStorage.setItem("internalid", bill);
        navigate(
          `/affidavit-prepare/${data.docid}/${role}?amount=${amount}&ref=${data.id}&seal=${sealAmt}`,
        );
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
      // setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onSelectOthers = () => {
    setConfirmSelect(false);
    setOpenTemp(true);
  };

  const onLoad = async () => {
    //for account registration

    try {
      setIsLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/affidavits/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();

      setIsLoading(false);
      console.log(data);
      if (data.code === 0) {
        var cdocs = [];
        data.docs.forEach((doc) => {
          const r = `LSJ/HC/AFF/${doc.docUploadLines[0]?.id}/${retrieveDocYear(
            doc,
          )}`;
          cdocs.push({ ...doc, refid: r });
        });
        console.log("after reconstruct");
        console.log(cdocs);
        console.log(cdocs, "log doc");
        setDocs(cdocs);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else {
        alert(data.status);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onSearch = async (sear) => {
    setIsLoading(true);

    // Transform case-oriented search structure to affidavit-specific structure
    const {
      caseTitle,
      caseNumber,
      caseTypeId,
      caseCategoryId,
      filingtype,
      caseprocess,
      ...otherPayloads
    } = sear;

    // Build affidavit-specific search payload
    const affidavitSearchPayload = {
      ...otherPayloads,
      affidavitId: caseTitle || caseNumber || "", // Use either title or number search
      // Add any other affidavit-specific fields here if needed in the future
    };

    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/affidavits/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(affidavitSearchPayload),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setIsLoading(false);
      if (data.code === 0) {
        var cdocs = [];
        data.docs.forEach((doc) => {
          const r = `LSJ/HC/AFF/${doc.docUploadLines[0]?.id}/${retrieveDocYear(
            doc,
          )}`;
          cdocs.push({ ...doc, refid: r });
        });
        setDocs(cdocs);
        setFilterTemps(cdocs);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };
  const onConfig = async () => {
    const urls = `${Constants.apiUrl}/setup/otherpayitems/affidavit`;
    console.log(`the calling url ${urls}`);

    try {
      const resp = await fetch(urls, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await resp.json();
      setConfig(data);
    } catch (error) {
      console.error(error);
    }
  };

  const retrieveDocYear = (currectdoc) => {
    return currectdoc?.uploadDate == null
      ? moment(new Date()).format("YYYY")
      : moment(currectdoc?.uploadDate).format("YYYY");
  };

  const onOptionProceed = () => {
    if (divisionId == 0) {
      setErr(
        "Please select the court division you want to process the Affidavit",
      );
      return;
    }
    setErr("");

    setOpenOption(false);

    if (option == "template") {
      setOpenTemp(true);
    } else if (option == "document") {
      setConfirmUpload(true);
    }
  };
  console.log(tab);
  const getCurrentGateway = async () => {
    //for account registration
    const url = `${Constants.apiUrl}/payment/current-gateway`;
    console.log(`the calling url ${url}`);
    try {
      setIsLoading(true);
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await resp.json();

      setIsLoading(false);
      console.log(data);
      if (data.code === 0) {
        setGateway(data.current);
      } else {
        alert(data.status);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onUploadOk = () => {
    //proceed to payment
    console.log("on upload click");
    setConfirmUpload(false);
    setIsPay(true);
  };

  const onUploadCancel = () => {
    setOpenOption(true);
    setConfirmUpload(false);
  };

  const onPickTemplate = () => {
    setOpenOption(true);
    setOption("template");
  };
  const onUploadTemplate = () => {
    setOpenOption(true);
    setOption("document");
  };

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  console.log({ profile, role });
  useEffect(() => {
    console.log(filterTemps);
  }, [filterTemps]);

  const isReadOnly =
    ["admin", "customer", "edm"].includes(profile.role.name.toLowerCase()) &&
    type === "view";

  return (
    <div className="affidavit-table">
      <div className="body">
        <div className="all-div">
          {role == "user" && !isReadOnly && (
            <div className="affidavit-action-wrapper">
              <button
                className="create-affidavit-button"
                onClick={onPickTemplate}
                type="button"
              >
                <p className="update-affidavit-button-sub-title">
                  Create Affidavit using Existing Template
                </p>
                <p className="update-affidavit-button-sub-text">
                  Fill an affidavit using an available template{" "}
                </p>
              </button>

              <button
                className="update-affidavit-button"
                onClick={onUploadTemplate}
                type="button"
              >
                <p className="update-affidavit-button-sub-title">
                  Upload Affidavit Document
                </p>
                <p className="update-affidavit-button-sub-text">
                  Use this if your affidavit was downloaded from an organisation
                </p>
              </button>
            </div>
          )}
        </div>
        <div className="tab_body">
          {role === "cfo" && (
            <>
              <CustomSearchSortHeader
                onSearch={onDirectSearch}
                frequentData={frequentData}
                isSearchOnly
                role="cfo"
              />
              <div className="exportdiv">
                <img
                  src={wordicon}
                  // onClick={() => onExport("word")}
                  style={{ cursor: "pointer" }}
                />
                <img
                  src={excelicon}
                  // onClick={() => onExport("excel")}
                  style={{ cursor: "pointer" }}
                />
                <img
                  src={pdficon}
                  // onClick={() => onExport("pdf")}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </>
          )}

          <div
            className={
              role === "user" ? "legal-counselor-search-container" : ""
            }
          >
            <div
              style={{ marginBottom: 20 }}
              className={
                "tab_section " +
                (role === "cfo " ? "" : "affidavits_tab_section ")
              }
            >
              <JisTabButton
                isActive={tab == "pending"}
                title="Pending"
                isRoleBased={false}
                onClick={() => onChangeTab("pending")}
              />
              <JisTabButton
                isActive={tab == "scheduled"}
                title="Scheduled"
                isRoleBased={false}
                onClick={() => onChangeTab("scheduled")}
              />
              <JisTabButton
                isActive={tab == "completed"}
                title={
                  profile.role.id === 11 ||
                  profile.role.id === 1 ||
                  profile.role.id === 6
                    ? "Commissioned"
                    : "Processed"
                }
                isRoleBased={false}
                onClick={() => onChangeTab("completed")}
              />
            </div>

            {role === "user" && (
              <div>
                <CustomSearchSortHeader
                  onSearch={onDirectSearch}
                  frequentData={frequentData}
                  isSearchOnly
                />
              </div>
            )}
          </div>
          <div className="tab_view">
            <div className="aff-table">
              <div>
                <div className="table">
                  <div class={role == "cfo" ? "section-cases" : "table-header"}>
                    <p>Affidavit Documents</p>
                    {/* <span className="total">{count}</span> */}
                  </div>
                  <div className="table-wrapper">
                    <table
                      className={
                        role == "cfo"
                          ? "case-table"
                          : "case-details-table full-border"
                      }
                    >
                      <thead>
                        <tr>
                          <th>Affidavit ID</th>
                          <th className="col-title">Affidavit Title</th>
                          <th className="col-medium">Date Created</th>
                          {(profile.role.id === 1 || profile.role.id === 6) &&
                            tab === "completed" && <th>Time</th>}
                          <th>Type</th>
                          {tab !== "completed" && (
                            <th className="col-title">Zoom Link</th>
                          )}
                          <th>
                            {tab === "pending"
                              ? "Schedule Date"
                              : tab === "scheduled"
                                ? "Scheduled Date"
                                : "Commissioned Date"}
                          </th>
                          {role === "cfo" && <th>Time</th>}
                          <th>View Document</th>
                          {role === "cfo" && tab !== "completed" && (
                            <th className="col-medium">Schedule</th>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {filterTemps.map((doc, i) => {
                          return (
                            <tr key={i}>
                              <td>{doc.docUploadLines[0].docRef}</td>
                              <td>
                                {doc.docUploadLines[0].documentTitle || "N/A"}
                              </td>

                              <td>
                                {doc.createDate
                                  ? moment(doc.createDate).format("D MMM, YYYY")
                                  : "N/A"}
                              </td>
                              {(profile.role.id === 1 ||
                                profile.role.id === 6) &&
                                tab === "completed" && (
                                  <td>
                                    {Constants.formatTime(
                                      doc.docUploadLines[0].completeDate,
                                    ) ?? "N/A"}
                                  </td>
                                )}
                              <td style={{ textTransform: "capitalize" }}>
                                {doc?.caseType}{" "}
                              </td>
                              {tab !== "completed" && (
                                <td
                                  className={
                                    doc.schedule == null ? "N/A" : "meet-link"
                                  }
                                >
                                  {" "}
                                  {doc.schedule != null ? (
                                    <a
                                      href={doc.zoomLink}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {" "}
                                      Zoom Link{" "}
                                    </a>
                                  ) : (
                                    "N/A"
                                  )}{" "}
                                </td>
                              )}
                              <td>
                                {tab === "completed" && (
                                  <>
                                    {doc.docUploadLines[0]?.completeDate
                                      ? moment(
                                          doc.docUploadLines[0].completeDate,
                                        ).format("Do MMMM, YYYY")
                                      : "N/A"}
                                  </>
                                )}
                                {tab === "pending" && <>N/A</>}
                                {tab === "scheduled" && (
                                  <>
                                    {doc.schedule != null
                                      ? moment(doc.schedule).format(
                                          "Do MMMM, YYYY",
                                        )
                                      : "N/A"}
                                  </>
                                )}
                              </td>
                              {role === "cfo" && (
                                <td>
                                  {tab === "completed" && (
                                    <>
                                      {doc.docUploadLines.length > 0
                                        ? moment(
                                            doc.docUploadLines[0].completeDate,
                                          ).format("h:mm a")
                                        : "N/A"}
                                    </>
                                  )}
                                  {tab === "pending" && <>N/A</>}
                                  {tab === "scheduled" && (
                                    <>
                                      {doc.schedule != null
                                        ? moment(doc.schedule).format("h:mm a")
                                        : "N/A"}
                                    </>
                                  )}
                                </td>
                              )}
                              <td className="view-affbtn">
                                {!doc.isCompleted && (
                                  <JisButton
                                    variant="plain"
                                    onClick={() => onView(doc)}
                                  >
                                    View
                                  </JisButton>
                                )}
                                {doc.isCompleted && (
                                  <div>
                                    {doc?.docUploadLines?.map((up, index) => {
                                      return (
                                        <div
                                          className="selected"
                                          onClick={() =>
                                            onUplineView(up, index)
                                          }
                                        >
                                          {up.documentTitle}
                                        </div>
                                      );
                                    })}
                                  </div>
                                )}
                              </td>

                              {role == "cfo" && !doc.isCompleted && (
                                <td>
                                  <JisButton
                                    variant="plain"
                                    icon="schedule"
                                    onClick={() => onSelectSchedule(doc)}
                                  >
                                    {doc.schedule == null
                                      ? "Schedule"
                                      : "Reschedule"}{" "}
                                  </JisButton>
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
                {filterTemps?.length > 0 && (
                  <Pagenated
                    onChangePageSize={(k) => setPageSize(k)}
                    size={pageSize}
                    total={count}
                    maxPage={20}
                    onPick={onPagePick}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <JisPrompt
          open={deleteBox}
          title="Delete"
          onOk={onDelete}
          onCancel={() => setDeleteBox(false)}
        >
          <p>Do you want to delete this Affidavit Template?</p>
        </JisPrompt>

        {openSuccess && (
          <div className={"success open"}>
            <div className="success-box">
              <h2>Successful</h2>
              <p> Template deleted successfully</p>
              <button className="red" onClick={() => setOpenSuccess(false)}>
                Continue
              </button>
            </div>
          </div>
        )}
      </div>
      <BackLoader open={isLoading} />
      {/* {alert.open && <JisAlert {...alert} onOk={onOk} />}  */}

      {openTemp && (
        <JisDialogForm
          title="AFFIDAVIT TEMPLATES"
          onClose={() => setOpenTemp(false)}
        >
          <AffidavitTemplate
            affidavit_templates={templates}
            onSelected={onSelectTemplate}
          />
        </JisDialogForm>
      )}

      {openOption && (
        <JisDialogForm
          minWidth="20%"
          title="Affidavit Document "
          onClose={() => setOpenOption(false)}
        >
          <div className="affidavit-option-dialog">
            <div>
              <h3 className="affidavit-document-title">
                Do you have Supporting Document (Exhibit)?{" "}
              </h3>

              <div className="exhibit-check-box-wrapper">
                <input
                  type="checkbox"
                  name="exhibit"
                  id="exhibit"
                  value={isExhibits}
                  onChange={(e) => setIsExhibits(e.target.checked)}
                />
                <label htmlFor="exhibit">
                  Please check this box if you have Supporting Document
                  (Exhibit)
                </label>
              </div>
              {isExhibits && (
                <div className="input-group">
                  <label> How many Exhibits to upload</label>
                  <div className="input-wrapper">
                    <DynamicIcon iname="save" />
                    <input
                      placeholder="exhibit"
                      type="number"
                      required={true}
                      name="countExhibits"
                      value={countExhibits}
                      onChange={(e) => setCountExhibits(e.target.value)}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="select-group">
              <label>
                {" "}
                Division <span className="required">*</span>{" "}
              </label>
              <select
                name="divisionId"
                value={divisionId}
                onChange={(e) => setDivisionId(e.target.value)}
              >
                <option value="">Select Division</option>
                {frequentData?.divisions.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.title}
                  </option>
                ))}
              </select>
              {err != "" && <div className="error">{err}</div>}
            </div>
            <div className="exhibit-amount-payable">
              <span>Amount Payable:</span>{" "}
              <span>N {Constants.formatCurrency(amount)}</span>
            </div>
            <button className="exhibit-button" onClick={onOptionProceed}>
              Process
            </button>
          </div>
        </JisDialogForm>
      )}

      <JisInternalPay
        isPay={isPay}
        name={profile?.firstName}
        email={profile?.primaryEmail}
        phone={profile?.primaryContactNumber}
        externalAmount={amount-sealAmt}
        internalAmount={sealAmt}
        amount={amount}
        docref={`${selectedtempid}-0-${profile?.id}-${profile?.username}`}
        note={`affidavit-${option}-${selectedtempid}-${isExhibits}-${countExhibits}-${divisionId}`}
        onCancel={onCancel}
        token={token}
      ></JisInternalPay>

      {confirmSelect && (
        <JisDialogForm
          minWidth="20%"
          title="Confirmation"
          onClose={() => setConfirmSelect(false)}
        >
          <div className="confirm-upload-dialog">
            <p className="confirm-document-title">Confirm Template Selection</p>
            <div>
              <p className="confirm-document-description">
                Please confirm if you selected the correct template '
                {activeSelect.title}''. Click 'Yes' to continue to payment or
                'No' to select a different template
              </p>
            </div>
            <div className="confirm-upload-btns">
              <button className="process-btn" onClick={onConfirmSelect}>
                Proceed
              </button>
              <button className="" onClick={onSelectOthers}>
                Cancel{" "}
              </button>
            </div>
          </div>
        </JisDialogForm>
      )}
      {/* <JisPrompt
        open={confirmSelect}
        title="Confirm Template Selection"
        onOk={onConfirmSelect}
        onCancel={onSelectOthers}
      >
        <p>
          Please confirm if you selected the correct template '
          {activeSelect.title}''. Click 'Yes' to continue to payment or 'No' to
          select a different template
        </p>
      </JisPrompt> */}
      {confirmUpload && (
        <JisDialogForm
          minWidth="20%"
          title="Confirmation"
          onClose={() => setConfirmUpload(false)}
        >
          <div className="confirm-upload-dialog">
            <p className="confirm-document-title">Confirm Template Selection</p>
            <div>
              <p className="confirm-document-description">
                Please confirm you choose Document upload option for your
                affidavit{" "}
                {`${
                  isExhibits
                    ? `with Exhibits. Number of exhibit  ${countExhibits} `
                    : ""
                }`}
              </p>
            </div>
            <div className="confirm-upload-btns">
              <button className="process-btn" onClick={onUploadOk}>
                Proceed
              </button>
              <button className="" onClick={onUploadCancel}>
                Re-Select
              </button>
            </div>
          </div>
        </JisDialogForm>
      )}

      {scheduleWindow && (
        <JisDialogForm
          title="Appointment Details"
          onClose={() => setScheduleWindow(false)}
        >
          <form onSubmit={onSaveSchedule}>

          
          <div>
            <div className="input-group">
              <label> Zoom Link</label>
              <div className="input-wrapper">
                <DynamicIcon iname="monitor-play" />
                <input
                  type="url"
                  placeholder="Zoom Link"
                  value={schedule.zoom}
                  onChange={(e) =>
                    setSchedule({ ...schedule, zoom: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="input-group">
              <label> Zoom meeting date</label>
              <div className="input-wrapper">
                <input
                  type="date"
                  placeholder="Zoom meeting date"
                  value={schedule.date}
                  onChange={(e) =>
                    setSchedule({ ...schedule, date: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="input-group">
              <label> Zoom meeting time</label>
              <div className="input-wrapper">
                <input
                  type="time"
                  placeholder="Zoom meeting time"
                  value={schedule.time}
                  onChange={(e) =>
                    setSchedule({ ...schedule, time: e.target.value })
                  }
                />
              </div>
            </div>

            <div>
              <div className="schedule_btn_wrapper">
                <button
                  variant={"outline"}
                  onClick={() => setScheduleWindow(false)}
                >
                  Cancel
                </button>
                <button type="submit">Schedule Appointment</button>
              </div>
            </div>
          </div>
          </form>
        </JisDialogForm>
      )}
      {isDetails && (
        <JisDialogForm
          title="Document Preview"
          onClose={() => setIsDetails(false)}
        >
          <div style={{ height: "90vh" }}>
            <PdfViewer pdfUrl={previewUrl} />
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default AffidavitDocuments;
